var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3427 80.8911C45.3427 79.8579 44.5387 79.0178 43.5499 79.0178C42.5611 79.0178 41.7571 79.8579 41.7571 80.8911C41.7571 86.6537 37.2712 91.3411 31.7562 91.3411C26.2412 91.3411 21.7633 86.6453 21.7633 80.8911C21.7633 79.8579 20.9593 79.0178 19.9705 79.0178C18.9817 79.0178 18.1777 79.8579 18.1777 80.8911C18.1777 88.0818 23.3229 94.0208 29.9715 94.9449V99.5819H24.8986C23.9098 99.5819 23.1059 100.422 23.1059 101.455C23.1059 102.488 23.9098 103.328 24.8986 103.328H38.6298C39.6187 103.328 40.4226 102.488 40.4226 101.455C40.4226 100.422 39.6187 99.5819 38.6298 99.5819H33.557V94.9449C40.1975 94.0208 45.3427 88.0734 45.3427 80.8911Z",
    stroke: "black",
    strokeWidth: 0.909635,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6757 85.8805C27.5113 85.8805 24.1348 82.3524 24.1348 78.001V67.1393C24.1348 62.7879 27.5113 59.2598 31.6757 59.2598C35.8401 59.2598 39.2166 62.7879 39.2166 67.1393V78.001C39.2166 82.3524 35.8401 85.8805 31.6757 85.8805Z",
    stroke: "black",
    strokeWidth: 0.909635,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.163 90.4001C105.163 92.1389 103.804 93.5586 102.14 93.5586H81.4144C79.7503 93.5586 78.3916 92.1389 78.3916 90.4001V72.1881C78.3916 70.4492 79.7503 69.0295 81.4144 69.0295H102.148C103.812 69.0295 105.171 70.4492 105.171 72.1881V90.4001H105.163Z",
    stroke: "black",
    strokeWidth: 0.909635,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.685 91.5595C118.685 92.6095 118.09 92.8783 117.359 92.1475L111.884 86.6536C111.153 85.9228 110.558 84.4611 110.558 83.4111V79.2109C110.558 78.1609 111.153 76.6992 111.884 75.9683L117.359 70.4829C118.09 69.7521 118.685 70.0209 118.685 71.0709V91.5595Z",
    stroke: "black",
    strokeWidth: 0.909635,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicCam);
export default __webpack_public_path__ + "static/media/mic-cam.ead8e1d7756c94c055af2cd86837a1d7.svg";
export { ForwardRef as ReactComponent };